import { Badge } from "@nexus/ui"
import { useTranslation } from "react-i18next"
import type { OpportunityAction } from "../../../types/opportunities.types"

const actionStyles: Record<OpportunityAction, string> = {
  launch: "border-status-success-border/40 bg-transparent text-status-success",
  scale: "border-primary/30 bg-transparent text-primary",
  test: "border-status-warning-border/40 bg-transparent text-status-warning",
}

export function OpportunityActionBadge({ action }: { action: OpportunityAction | null }) {
  const { t } = useTranslation()
  if (!action) {
    return (
      <span className="text-muted-foreground/50" aria-label={t("opportunities.actions.none")}>
        —
      </span>
    )
  }
  return (
    <Badge variant="outline" className={actionStyles[action]}>
      {t(`opportunities.actions.${action}`)}
    </Badge>
  )
}
